// extracted by mini-css-extract-plugin
export default {"sectionView":"SectionView_sectionView__iVu6H","sectionView__item":"SectionView_sectionView__item__y+Zg9"};